import React from "react"
import { Grid, Dropdown, Button } from "semantic-ui-react"
import { FormContainer, DetailsEditor } from "uikit"
import { goalTypes } from "./goalTypes"

const GoalTypeSelectGrid = ({
  data: {
    fields: { goalType },
    onSubmit,
    hasError,
    error
  },
  submitLabel = "Continue",
  onCancel,
  goalTypeOptions
}) => (
  <DetailsEditor heading="Add a Goal">
    <Grid>
      <Grid.Row
        style={{
          background: "#edf7ff",
          padding: "3em",
          borderTop: "1px solid #ccc"
        }}
      >
        <Grid.Column textAlign="center">
          <Dropdown
            placeholder="Select Type of Goal"
            data-testid="goal_type"
            selection
            options={goalTypeOptions}
            {...goalType}
            error={!!goalType.error}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row centered style={{ minHeight: "20em" }}>
        <Grid.Column
          width={10}
          textAlign="center"
          style={{ fontSize: "16px", paddingTop: "21px", color: "#aaa" }}
        >
          {goalType.value
            ? goalTypes[goalType.value].description
            : "Please select the type of goal you wish to add."}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row style={{ borderTop: "1px solid #ccc" }} columns={2}>
        <Grid.Column textAlign="left" style={{ paddingLeft: "2em" }}>
          <Button
            basic
            content="Cancel"
            onClick={onCancel}
            primary
            data-testid="cancel"
          />
        </Grid.Column>
        <Grid.Column
          textAlign="right"
          style={{ paddingRight: "2em", paddingBottom: "1em" }}
        >
          <Button
            content={submitLabel}
            onClick={onSubmit}
            primary
            data-testid="continue"
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </DetailsEditor>
)

const GoalTypeSelector = FormContainer(
  {
    goalType: {
      type: "string",
      required: true
    }
  },
  (fields, ...form) => {}
)(GoalTypeSelectGrid)

export default GoalTypeSelector
